import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";
import { Lock } from "lucide-react";

const LOGO = "https://customer-assets.emergentagent.com/job_ff078f22-bc2b-467a-b845-6483b385dad8/artifacts/c2lq75mw_image.png";

export default function AdminLogin() {
    const { user, login, loading } = useAuth();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const nav = useNavigate();

    if (!loading && user) return <Navigate to="/admin" replace />;

    async function onSubmit(e) {
        e.preventDefault();
        setSubmitting(true);
        const res = await login(email, password);
        setSubmitting(false);
        if (res.ok) {
            toast.success("Bienvenue !");
            nav("/admin");
        } else {
            toast.error(res.error);
        }
    }

    return (
        <div className="min-h-screen bg-kayama-cream flex items-center justify-center px-6 py-12" data-testid="page-admin-login">
            <div className="w-full max-w-md">
                <div className="text-center mb-10">
                    <img src={LOGO} alt="Kayama" className="h-16 w-auto mx-auto" />
                    <p className="overline mt-6">Espace administration</p>
                    <h1 className="font-heading text-4xl font-light text-kayama-brown mt-2">Connexion</h1>
                </div>

                <form onSubmit={onSubmit} className="bg-kayama-paper border border-kayama-line p-8 space-y-6" data-testid="admin-login-form">
                    <div>
                        <label className="label-k">Email</label>
                        <input
                            type="email"
                            className="input-k"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            autoFocus
                            data-testid="admin-login-email"
                        />
                    </div>
                    <div>
                        <label className="label-k">Mot de passe</label>
                        <input
                            type="password"
                            className="input-k"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            data-testid="admin-login-password"
                        />
                    </div>
                    <button
                        type="submit"
                        disabled={submitting}
                        className="btn-primary-k w-full justify-center disabled:opacity-60"
                        data-testid="admin-login-submit"
                    >
                        <Lock size={14} /> {submitting ? "Connexion…" : "Se connecter"}
                    </button>
                </form>

                <p className="text-center text-xs text-kayama-brown-3 mt-6">
                    Accès réservé · Kayama Saveurs
                </p>
            </div>
        </div>
    );
}
